// Discover's character filters under the `character_feed_filters` flag (src/component/DiscoverFilters.tsx): the values
// each may take, the first the default, and the /api/get_chat_feed request they make. Their own module so the chat
// context, which every page of its group loads, does not pull in the filter bar.
export const CHARACTER_STYLES = ['all', 'realistic', 'anime'] as const
export const CHARACTER_SEXUALITIES = ['straight', 'gay', 'lesbian'] as const
export const CHARACTER_SORTS = ['newest', 'popular'] as const

// A value read back from storage, or the default when it is missing or no longer offered.
export function remembered(
  saved: string | null | undefined,
  allowed: readonly string[],
): string {
  return saved && allowed.includes(saved) ? saved : allowed[0]
}

type Filters = {
  style: string
  sexuality: string
  gender: string
  sort: string
}

// The cache key of one combination of filters.
export function characterFeedKey({
  style,
  sexuality,
  gender,
  sort,
}: Filters): string {
  return `${style}|${sexuality}|${gender}|${sort}`
}

// The chat feed request for a page after `lastDocId` (null: the first): the backend reads `style` anime | realistic
// (a character's style is its picture's model), `sexuality` straight (neither gay nor lesbian) | gay | lesbian and
// `sort` popular | newest; `model` stays "all", the exact-model filter being the old selects'.
export function characterFeedBody(
  lastDocId: string | null,
  safe: boolean,
  filters: Filters,
) {
  const { style, sexuality, gender, sort } = filters
  return {
    last_doc_id: lastDocId,
    safe,
    model: 'all',
    gender,
    style,
    sexuality,
    sort,
  }
}

// A page appended to what is already shown, without the characters already in it: the popular sort's cursor is a
// save count that moves, so a page can repeat a character (someone saved it between two pages).
export function withoutRepeats<T extends { id: string }>(
  shown: T[] | undefined,
  page: T[],
): T[] {
  const seen = new Set((shown || []).map((c) => c.id))
  return [...(shown || []), ...page.filter((c) => !seen.has(c.id))]
}
